export const colorList = [
  {
    textColor: "#be2217",
    bgColor: "#ffe3e1",
  },
  {
    textColor: "#2d6830",
    bgColor: "#e3f5e3",
  },
  {
    textColor: "#0054fc",
    bgColor: "#d6ecff",
  },
  {
    textColor: "#0a7394",
    bgColor: "#cefaff",
  },
  {
    textColor: "#662bd6",
    bgColor: "#ece9fe",
  },
  {
    textColor: "#25272c",
    bgColor: "#edeef1",
  },
];

export const usageList = [
  {
    label: "Payment",
    value: "payment",
  },
  {
    label: "Essilor Experts",
    value: "essilor_experts",
  },
  {
    label: "Essilor Partner",
    value: "essilor_partner",
  },
  {
    label: "Nikon Lenswear Partner",
    value: "nikon_lenswear_partner",
  },
];

export const orderTypeList = [
  {
    label: "Stock",
    value: "stock",
  },
  {
    label: "RX",
    value: "rx",
  },
];

export const getOrderTypeLabel = (value: string) => {
  const orderType = orderTypeList.find((ot) => ot.value === value);
  if (orderType) return orderType.label;
};

export const taskTypeList = [
  {
    label: "New Order",
    value: "new",
  },
  {
    label: "Claim",
    value: "claim",
  },
  {
    label: "Exchange",
    value: "exchange",
  },
];

export const orderCycleList = [
  {
    label: "Morning",
    value: "morning",
  },
  {
    label: "Afternoon",
    value: "afternoon",
  },
  {
    label: "Overdue",
    value: "overdue",
  },
];

export const getOrderCycleLabel = (value: string) => {
  const orderCycle = orderCycleList.find((oc) => oc.value === value);
  if (orderCycle) return orderCycle.label;
};

export const getTaskTypeLabel = (value: string) => {
  const taskType = taskTypeList.find((ot) => ot.value === value);
  if (taskType) return taskType.label;
};

export const contactTypeList = [
  {
    label: "Chat",
    value: "chat",
  },
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Phone + Chat",
    value: "phone_chat",
  },
  {
    label: "Phone + Email",
    value: "phone_email",
  },
];

export const actionStatusList = [
  {
    label: "In Process",
    value: "in_progress",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Closed",
    value: "closed",
  },
];

export const currentStatusList = [
  {
    label: "Task Created",
    value: "created",
  },
  {
    label: "Calling",
    value: "calling",
  },
  {
    label: "Order Created",
    value: "order_created",
  },
  {
    label: "Support Pending",
    value: "support_pending",
  },
  {
    label: "Pending In Progress",
    value: "pending_inprogress",
  },
  {
    label: "Support Closed",
    value: "support_closed",
  },
  {
    label: "Waiting QC",
    value: "waiting_qc",
  },
  {
    label: "QC Calling",
    value: "qc_calling",
  },
  {
    label: "QC Pass",
    value: "qc_pass",
  },
  {
    label: "Reject",
    value: "reject",
  },
];

export const getCurrentStatusLabel = (value: string) => {
  const currentStatus = currentStatusList.find((cs) => cs.value === value);
  if (currentStatus) return currentStatus.label;
};

export const searchTypeList = [
  {
    label: "ECP Code",
    value: "ecp_code",
  },
  {
    label: "Task Number",
    value: "number",
  },
  {
    label: "Tracking Number",
    value: "tracking_number",
  },
  {
    label: "Status",
    value: "current_status",
  },
  {
    label: "Created Date",
    value: "created_date",
  },
  {
    label: "Created By",
    value: "create_task_by",
  },
  {
    label: "Key-In By",
    value: "key_in_by",
  },
];

export const channelList = [
  {
    label: "System",
    value: "system",
  },
  {
    label: "Line",
    value: "line",
  },
  {
    label: "Email",
    value: "email",
  },
];

export const channelFilterList = [
  {
    label: "Line",
    value: "system",
  },
  {
    label: "Email",
    value: "email",
  },
];

// Text color used to visually distinguish task types in lists and detail views.
export const getTaskTypeColor = (value?: string): string => {
  switch (value) {
    case "new":
      return "#0054fc";
    case "claim":
      return "#d97706";
    case "exchange":
      return "#ec4899";
    default:
      return "#25272c";
  }
};

// Chip background/text colors for the create_channel badge.
// Keeps LINE green, gives Email a blue badge, falls back to neutral gray.
export const getCreateChannelChipColors = (
  value?: string,
): { bgColor: string; textColor: string } => {
  switch (value) {
    case "line":
      return { bgColor: "#4CAF50", textColor: "#ffffff" };
    case "email":
      return { bgColor: "#2196F3", textColor: "#ffffff" };
    default:
      return { bgColor: "#f3f4f6", textColor: "#374151" };
  }
};
